import { render, staticRenderFns } from "./TrainBoxKO.vue?vue&type=template&id=76f33d00&scoped=true&"
import script from "./TrainBoxKO.vue?vue&type=script&lang=ts&"
export * from "./TrainBoxKO.vue?vue&type=script&lang=ts&"
import style0 from "./TrainBoxKO.vue?vue&type=style&index=0&id=76f33d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f33d00",
  null
  
)

export default component.exports